

import { createSlice, createAsyncThunk, nanoid } from "@reduxjs/toolkit";
import { setResultModalData, showModal } from "../modal/modalSlice";
import moment from "moment";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {
    allQuestions: [],
    isLoadingGetAllQuestions: false,

    allTitles: [],

    isLoadingAddNewQuestions: false,

    aiQuestionGroupData: null,

    questionList:[
        {
            id:nanoid(),
            question: "",
            answer: "",
            isActive: true
        }
    ],

    updateQuestionsList: [],
    constantUpdateQuestionsList: [],
    updateQuestionsTitleData: null,

    isLoadingAddChatSubTitleWithQuestion: false,

    isLoadingUpdateChatQuestion: false,
    isLoadingAddAiChatTitle: false,

    isLoadingDeleteAIChatQuestion: false,
    isLoadingDeleteAIChatSubTitle: false,

    isLoadingDeleteQuestionGroup: false,

    isLoadingUpdateAiTitleOrder: false,
    isLoadingUpdateAiSubTitleOrder: false,

    aiTitleData: null,
    aiSubTitleData:null,

    aiChatTitleDetails: [],
    
    questionItemData: null,
    allPastAiMessagesCount: null,
    
    allPastAiMessages: [],

    //! bu detayları göstermek için
    aiChatItemDetails: [],

    isLoadingGetAiRoleContent:false,
    isLoadingUpdateAiRoleContent:false,
    aiRole: "",


    isLoadingGetAllPastAiNewModelMessages: false,
    allPastAiMessagesCountNewModel: null,
    allPastAiMessagesNewModel: [],

    singleAiNewModelChatAllMessages: []
}



//! bu tüm hepsini çeken
export const getAllQuestions = createAsyncThunk("aiControl/getAllQuestions", async(_,thunkApi)=> {
    try {
        const {data}  = await axiosInstance.get('/ChataiMessages/GetAll')
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


//! bu yeni soru ekleyen
export const addNewQuestions = createAsyncThunk("aiControl/addNewQuestions", async(questions,thunkApi)=> {
    try {
        const {data} = await axiosInstance.post('/ChataiMessages/GetAll', questions)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Girdiniz başarıyla eklenmiştir.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! bu yeni subTitle ile beraber soru ekleyen
export const addChatSubTitleWithQuestion = createAsyncThunk("aiControl/addChatSubTitleWithQuestion", async(questions,thunkApi)=> {
    try {
        const {data} = await axiosInstance.post('/ChataiMessages/AddChatSubTitleWithQuestion', questions)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Girdiniz başarıyla eklenmiştir.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


//! bu tek bir soru silen
export const deleteAIChatQuestion = createAsyncThunk("aiControl/deleteAIChatQuestion", async(id,thunkApi)=> {
    try {
        const {data} = await axiosInstance.delete(`/ChataiMessages/DeleteChatQuestion?Id=${id}`)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Girdi başarıyla silinmiştir.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! bu sub title ve içiindeki soruları silen
export const deleteAIChatSubTitle = createAsyncThunk("aiControl/deleteAIChatSubTitle", async(id,thunkApi)=> {
    try {
        const {data} = await axiosInstance.delete(`/ChataiMessages/DeleteChatSubTitle?Id=${id}`)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Alt Başlık başarıyla silinmiştir.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const addAiChatTitle = createAsyncThunk("aiControl/addAiChatTitle", async(chatTitle, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/ChataiMessages/AddChatTitle`, chatTitle)

        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Alt Başlık başarıyla silinmiştir.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const deleteChatTitle = createAsyncThunk("aiControl/deleteChatTitle", async(id, thunkApi)=> {
    try {
        const {data} = await axiosInstance.delete(`/ChataiMessages/DeleteChatTitle?TitleId=${id}`)

        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Başlık başarıyla silinmiştir.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const updateAiChatTitle = createAsyncThunk("aiControl/updateAiChatTitle", async(updatedTitle, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/ChataiMessages/UpdateChatTitle`, updatedTitle)

        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Başlık başarıyla güncellenmiştir.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const updateChatQuestion = createAsyncThunk("aiControl/updateChatQuestion", async(updatedData,thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/ChataiMessages/UpdateChatQuestions`, updatedData)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Güncelleme işlemi başarıyla gerçekleştirilmiştir.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const updateChatSubTitle = createAsyncThunk("aiControl/updateChatSubTitle", async(updatedData,thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/ChataiMessages/UpdateSubTitle`, updatedData)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Güncelleme işlemi başarıyla gerçekleştirilmiştir.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const updateAiTitleOrder = createAsyncThunk("aiControl/updateAiTitleOrder", async(updatedData,thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/ChataiMessages/UpdateTitleOrder`, updatedData)

        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Güncelleme işlemi başarıyla gerçekleştirilmiştir.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const updateAiSubTitleOrder = createAsyncThunk("aiControl/updateAiSubTitleOrder", async(updatedData,thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/ChataiMessages/updateAiSubTitleOrder`, updatedData)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Güncelleme işlemi başarıyla gerçekleştirilmiştir.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
            thunkApi.dispatch(getAllQuestions())
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const updateAiTitleActivity = createAsyncThunk("aiControl/updateAiTitleActivity", async(updatedData,thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/ChataiMessages/UpdateChatTitleActivity`, updatedData)

        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Güncelleme işlemi başarıyla gerçekleştirilmiştir.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
            thunkApi.dispatch(getAllQuestions())
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const updateAiSubTitleActivity = createAsyncThunk("aiControl/updateAiSubTitleActivity", async(updatedData,thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/ChataiMessages/UpdateChatSubTitleActivity`, updatedData)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Güncelleme işlemi başarıyla gerçekleştirilmiştir.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
            thunkApi.dispatch(getAllQuestions())
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


//! bu tüm hepsini çeken
export const getAllPastAiMessages = createAsyncThunk("aiControl/getAllPastAiMessages", async({page},thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/ChataiMessages/GetAllAiMessages?page=${page}`)
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getSingleAiChatAllMessages = createAsyncThunk("aiControl/getSingleAiChatAllMessages", async(item,thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/ChataiMessages/GetAllChatMessagesById?ChatId=${item.chatId}`)
        return {data, name: item.adSoyadUnvan}
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const getAiRoleContent = createAsyncThunk("aiControl/GetAiRoleContent", async(_,thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/Ai/GetAiRoleContent`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const updateAiRoleContent = createAsyncThunk("aiControl/UpdateAiRoleContent", async(body ,thunkApi)=> {
    try {
        const {data} = await axiosInstance.put(`/Ai/UpdateAiRoleContent`, body)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getAllPastAiNewModelMessages = createAsyncThunk("aiControl/getAllPastAiNewModelMessages", async({page},thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/MobileAiChat/AdminGetAllMobileAiChats?page=${page}`)
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})



const aiControlSlice = createSlice({
    name: "aiControl",
    initialState,
    reducers: {
        
        addNewQuestionLocal: (state) => {
            state.questionList = [...state.questionList, {
                    id:nanoid(),
                    question: "",
                    answer: "",
                    isActive: true
            }]
        },

        getAiQuestionGroupData:(state, action) => {
            state.aiQuestionGroupData = action.payload
        },

        //! bu eklerken güncellmek için
        updateQuestionList: (state,action) => {
            const {id} = action.payload
            state.questionList = state.questionList.map((item) => {
                if(item.id === id){
                    return {...item, ...action.payload}
                }
                else{
                    return item
                }
            })
        },

        //! bu eklendikte sonra update için
        updateQuestionListUpdate: (state,action) => {
            const {id} = action.payload
            state.updateQuestionsList = state.updateQuestionsList.map((item) => {
                if(item.id === id){
                    return {...item, ...action.payload}
                }
                else{
                    return item
                }
            })
        },

        getUpdateQuestionsData: (state, action) => {
            state.updateQuestionsList = action.payload.messages
            state.constantUpdateQuestionsList = action.payload.messages
            state.updateQuestionsTitleData = {title: action.payload.subTitleName, titleId: action.payload.id}
        },

        getAiTitleData: (state, action) => {
            state.aiTitleData = action.payload
        },

        getAiSubTitleData: (state, action) => {
            state.aiSubTitleData = action.payload
        },

        getaAiChatTitleDetails: (state, action) => {
            state.aiChatTitleDetails = action.payload
        },

        //! yapay zeka mesajlaşma geçmişinde bir chatin geçmişinde tüm mesajlar için(genelde reset için)
        setAiChatDetails: (state, action) => {
            state.aiChatItemDetails = action.payload
        },

        //! bu tek birini güncellemek için
        getAiQuestionItemData: (state, action) => {
            state.questionItemData = action.payload
        },

        //! mobil yeni model ai sohbet geçmişi
        setSingleAiNewModelChatAllMessages: (state, action) => {
            state.singleAiNewModelChatAllMessages = action.payload
        }
    },
    extraReducers:(builder)=> {
        builder
            //! getAllQuestions
            .addCase(getAllQuestions.pending, (state)=> {
                state.isLoadingGetAllQuestions = true
            })
            .addCase(getAllQuestions.fulfilled, (state, action)=> {
                state.isLoadingGetAllQuestions = false

                const list = action.payload.$values.map((item) => {
                    return {
                        id: item.id,
                        titleName: item.titleName,
                        order: item.order,
                        isActive: item.isActive,
                        subTitles: item.chatAiReadyDefaultMessages.$values.map(innerItem => {
                           return {
                                id: innerItem.id,  
                                parentTitleId: innerItem.parentTitleId,
                                subTitleName: innerItem.subTitleName,
                                createDate: innerItem.createDate,
                                subTitleOrder: innerItem.subTitleOrder,
                                isActive: innerItem.isActive,
                                messages: innerItem.aidefaultMesssages.$values.map(inInnerItem => {
                                    return {
                                        id: inInnerItem.id,
                                        parentSubTitleId: inInnerItem.chatAiReadyDefaultMessageId,
                                        isActive: inInnerItem.isActive,
                                        question: inInnerItem.question,
                                        answer: inInnerItem.answer,
                                        createDate: inInnerItem.createDate
                                    }
                                })
                            }
                        })
                    }
                })
                state.allQuestions = list

                state.allTitles = action.payload.$values.map((item) => {
                    return {
                        titleId: item.id,
                        titleName: item.titleName,
                        order:item.order,
                        subTitles: item.chatAiReadyDefaultMessages.$values.map(innerItem => {
                            return {
                                subTitleId: innerItem.id,
                                subTitleName: innerItem.subTitleName,
                                parentTitleId: item.id,
                                subTitleOrder: innerItem.subTitleOrder,
                            }
                        })
                    }
                })
            })
            .addCase(getAllQuestions.rejected, (state, action)=> {
                state.isLoadingGetAllQuestions = false
            })

            //! addNewQuestions
            .addCase(addNewQuestions.pending, (state)=> {
                state.isLoadingAddNewQuestions = true
            })
            .addCase(addNewQuestions.fulfilled, (state, action)=> {
                state.isLoadingAddNewQuestions = false
                const newMessages = action.payload.data.$values
                const {titleId, subTitleId} = newMessages[0]
                state.allQuestions = state.allQuestions.map(item => {
                    if(item.id === titleId){
                        return {
                            ...item,
                            subTitles: item.subTitles.map(innerItem =>{
                                if(innerItem.id === subTitleId){
                                    return {
                                        ...innerItem,
                                        messages: [...innerItem.messages, ...newMessages]
                                    }
                                }
                                else{
                                    return innerItem
                                }
                            })
                        }
                    }
                    else{
                        return item
                    }
                })
                state.questionList = [{
                    id:nanoid(),
                    question: "",
                    answer: "",
                    isActive: true
                }]
            })
            .addCase(addNewQuestions.rejected, (state, action)=> {
                state.isLoadingAddNewQuestions = false
                state.questionList = [{
                    id:nanoid(),
                    question: "",
                    answer: "",
                    isActive: true
                }]
            })

            //! addChatSubTitleWithQuestion
            .addCase(addChatSubTitleWithQuestion.pending, (state)=> {
                state.isLoadingAddChatSubTitleWithQuestion = true
            })
            .addCase(addChatSubTitleWithQuestion.fulfilled, (state, action)=> {
                state.isLoadingAddChatSubTitleWithQuestion = false
                const {subTitleId, titleId, aidefaultMesssages, subTitleName} = action.payload.data
                state.allQuestions = state.allQuestions.map(item => {
                    if(item.id === titleId){
                        return {...item, subTitles: [...item.subTitles, {
                                id: subTitleId,
                                parentTitleId: titleId,
                                subTitleName:subTitleName,
                                messages: aidefaultMesssages.$values
                            }]
                        }
                    }
                    else{
                        return item
                    }
                })
                state.questionList = [{
                    id:nanoid(),
                    question: "",
                    answer: "",
                    isActive: true
                }]
            })
            .addCase(addChatSubTitleWithQuestion.rejected, (state, action)=> {
                state.isLoadingAddChatSubTitleWithQuestion = false
                state.questionList = [{
                    id:nanoid(),
                    question: "",
                    answer: "",
                    isActive: true
                }]
            })

            //! deleteAIChatQuestion
            .addCase(deleteAIChatQuestion.pending, (state)=> {
                state.isLoadingDeleteAIChatQuestion = true
            })

            .addCase(deleteAIChatQuestion.fulfilled, (state, action)=> {
                state.isLoadingDeleteAIChatQuestion = false
                const {messageId, subTitleId, titleId} = action.payload.data

                state.allQuestions = state.allQuestions.map(item => {
                    if(item.id === titleId){
                        return {
                            ...item,
                            subTitles: item.subTitles.map(innerItem =>{
                                if(innerItem.id === subTitleId){
                                    return {
                                        ...innerItem,
                                        messages: innerItem.messages.filter(inInnerItem => {
                                            return inInnerItem.id !== messageId
                                        })
                                    }
                                }
                                else{
                                    return innerItem
                                }
                            })
                        }
                    }
                    else{
                        return item
                    }
                })
            })
            .addCase(deleteAIChatQuestion.rejected, (state, action)=> {
                state.isLoadingDeleteAIChatQuestion = false
            })

            //! deleteAIChatSubTitle
            .addCase(deleteAIChatSubTitle.pending, (state)=> {
                state.isLoadingDeleteAIChatSubTitle = true
            })
            .addCase(deleteAIChatSubTitle.fulfilled, (state, action)=> {
                state.isLoadingDeleteAIChatSubTitle = false
                const {subTitleId, titleId } = action.payload.data
                state.allQuestions = state.allQuestions.map((item) => {
                    if(item.id === titleId){
                        return {...item, subTitles: item.subTitles.filter(innerItem => innerItem.id !== subTitleId)}
                    }
                    else{
                        return item
                    }
                })

            })
            .addCase(deleteAIChatSubTitle.rejected, (state, action)=> {
                state.isLoadingDeleteAIChatSubTitle = false
            })

            //! addAiChatTitle
            .addCase(addAiChatTitle.pending, (state)=> {
                state.isLoadingAddAiChatTitle = true
            })
            .addCase(addAiChatTitle.fulfilled, (state, action)=> {
                state.isLoadingAddAiChatTitle = false
                const {titleId, titleName} =action.payload.data
                state.allQuestions = [...state.allQuestions, {id: titleId, titleName, subTitles:[]}]
                // state.controlList = action.payload.data.$values
            })
            .addCase(addAiChatTitle.rejected, (state, action)=> {
                state.isLoadingAddAiChatTitle = false
            })

            //! deleteChatTitle
            .addCase(deleteChatTitle.pending, (state)=> {
                state.isLoadingUpdateChatQuestion = true
            })
            .addCase(deleteChatTitle.fulfilled, (state, action)=> {
                state.isLoadingUpdateChatQuestion = false
                state.allQuestions = state.allQuestions.filter(item => item.id !== action.payload.data.id)
            })
            .addCase(deleteChatTitle.rejected, (state, action)=> {
                state.isLoadingUpdateChatQuestion = false
            })

            //! updateAiChatTitle
            .addCase(updateAiChatTitle.pending, (state)=> {
                state.isLoadingUpdateChatQuestion = true
            })
            .addCase(updateAiChatTitle.fulfilled, (state, action)=> {
                state.isLoadingUpdateChatQuestion = false
                const {titleName, id} = action.payload.data
                state.allQuestions = state.allQuestions.map(item => {
                    if(item.id === id){
                        return {...item, titleName}
                    } 
                    else{
                        return item
                    }
                })
            })
            .addCase(updateAiChatTitle.rejected, (state, action)=> {
                state.isLoadingUpdateChatQuestion = false
            })


            //! updateAiChatSubTitle
            .addCase(updateChatSubTitle.pending, (state)=> {
                state.isLoadingUpdateChatQuestion = true
            })
            .addCase(updateChatSubTitle.fulfilled, (state, action)=> {
                state.isLoadingUpdateChatQuestion = false
                const {subTitleId, subTitleName, titleId} = action.payload.data
                state.allQuestions = state.allQuestions.map((item) => {
                    if(item.id === titleId){
                        return {...item, subTitles: item.subTitles.map((subItem) => {
                            if(subItem.id === subTitleId){
                                return {...subItem, subTitleName }
                            }
                            else{
                                return subItem
                            }
                        })}
                    }
                    else{
                        return item
                    }
                })
            })
            .addCase(updateChatSubTitle.rejected, (state, action)=> {
                state.isLoadingUpdateChatQuestion = false
            })

            
            .addCase(updateChatQuestion.pending, (state)=> {
                state.isLoadingUpdateChatQuestion = true
            })
            .addCase(updateChatQuestion.fulfilled, (state, action)=> {
                state.isLoadingUpdateChatQuestion = false
                const {subTitleId, titleId, aidefaultMesssages} = action.payload.data
                const updatedMessages = aidefaultMesssages.$values


                state.allQuestions = state.allQuestions?.map(item => {
                    if(item?.id === titleId){
                        return {
                            ...item,
                            subTitles: item?.subTitles?.map(innerItem =>{
                                if(innerItem?.id === subTitleId){
                                    return {
                                        ...innerItem,
                                        messages: innerItem?.messages?.map(messageItem => {
                                            const updatedItem = updatedMessages?.find(updatedItem => updatedItem?.id === messageItem?.id)
                                            if(updatedItem){
                                                return updatedItem
                                            }
                                            else{
                                                return messageItem
                                            }
                                        })
                                    }
                                }
                                else{
                                    return innerItem
                                }
                            })
                        }
                    }
                    else{
                        return item
                    }
                })
            })
            .addCase(updateChatQuestion.rejected, (state, action)=> {
                state.isLoadingUpdateChatQuestion = false
            })

            .addCase(updateAiTitleOrder.pending, (state)=> {
                state.isLoadingUpdateAiTitleOrder = true
            })
            .addCase(updateAiTitleOrder.fulfilled, (state, action)=> {
                state.isLoadingUpdateAiTitleOrder = false
                const updatedData = action.payload.data.$values
                const list = state.allQuestions.map((item) => {
                    const updatedItem = updatedData.find((innerItem) => {
                        return item.id === innerItem.titleId
                    })
                    if(updatedItem){
                        return {...item, order: updatedItem.order}
                    }
                    else{
                        return item
                    }
                })
                state.allQuestions = list.sort((a, b) => a.order - b.order);
                state.allTitles = list.sort((a, b) => a.order - b.order).map((item) => {
                    return {
                        titleId: item.id,
                        titleName: item.titleName,
                        order:item.order,
                        subTitles: item.subTitles.map(innerItem => {
                            return {
                                subTitleId: innerItem.id,
                                subTitleName: innerItem.subTitleName,
                                parentTitleId: item.id,
                            }
                        })
                    }
                })
            })
            .addCase(updateAiTitleOrder.rejected, (state)=> {
                state.isLoadingUpdateAiTitleOrder = false
            })

            .addCase(updateAiSubTitleOrder.pending, (state)=> {
                state.isLoadingUpdateAiSubTitleOrder = true
            })
            .addCase(updateAiSubTitleOrder.fulfilled, (state)=> {
                state.isLoadingUpdateAiSubTitleOrder = false
            })
            .addCase(updateAiSubTitleOrder.rejected, (state)=> {
                state.isLoadingUpdateAiSubTitleOrder = false
            })
            
            .addCase(getAllPastAiMessages.pending, (state)=> {
                state.isLoadingUpdateAiSubTitleOrder = true
            })
            .addCase(getAllPastAiMessages.fulfilled, (state, action)=> {
                state.isLoadingUpdateAiSubTitleOrder = false
                const messageHistoryByDate = action.payload.data.chataiMessages.$values?.reduce((acc, message) => {
                    const { createDate, ...restOfMessage } = message;
                    const group = acc.find(
                        (item) => moment(item.createDate).format('L') === moment(createDate).format('L')
                    );
                    if (!group) {
                        acc.push({
                            createDate: createDate,
                            data: [restOfMessage],
                        });
                    } else {
                        group.data.push(restOfMessage);
                    }
                    return acc?.sort((a, b) => moment(b?.createDate) - moment(a?.createDate));
                }, []);
                state.allPastAiMessagesCount = action.payload.data.count
                state.allPastAiMessages = messageHistoryByDate
            })
            .addCase(getAllPastAiMessages.rejected, (state)=> {
                state.isLoadingUpdateAiSubTitleOrder = false
            })


            .addCase(getSingleAiChatAllMessages.pending, (state)=> {
                state.isLoadingUpdateAiSubTitleOrder = true
            })
            .addCase(getSingleAiChatAllMessages.fulfilled, (state, action)=> {
                const {data, name} = action.payload
                state.isLoadingUpdateAiSubTitleOrder = false
                state.aiChatItemDetails = data.data.$values.map(item => {
                    return {
                        ...item, name
                    }
                })
            })
            .addCase(getSingleAiChatAllMessages.rejected, (state)=> {
                state.isLoadingUpdateAiSubTitleOrder = false
            })


            .addCase(getAiRoleContent.pending, (state)=> {
                state.isLoadingGetAiRoleContent = true
            })
            .addCase(getAiRoleContent.fulfilled, (state, action)=> {
                state.isLoadingGetAiRoleContent = false
                state.aiRole = action.payload
            })
            .addCase(getAiRoleContent.rejected, (state)=> {
                state.isLoadingGetAiRoleContent = false
            })


            .addCase(updateAiRoleContent.pending, (state)=> {
                state.isLoadingUpdateAiRoleContent = true
            })
            .addCase(updateAiRoleContent.fulfilled, (state, action)=> {
                state.isLoadingUpdateAiRoleContent = false
                state.aiRole = action.payload
            })
            .addCase(updateAiRoleContent.rejected, (state)=> {
                state.isLoadingUpdateAiRoleContent = false
            })


            .addCase(getAllPastAiNewModelMessages.pending, (state)=> {
                state.isLoadingGetAllPastAiNewModelMessages = true
            })
            .addCase(getAllPastAiNewModelMessages.fulfilled, (state, action)=> {
                state.isLoadingGetAllPastAiNewModelMessages = false
                state.allPastAiMessagesCount = action.payload.data.count
                const messageHistoryByDate = action.payload.data.items.$values?.reduce((acc, message) => {
                const { createdAt, ...restOfMessage } = message;
                const createdLocal = moment.utc(createdAt).utcOffset(3);

                const group = acc.find(item =>
                    moment.utc(item.createdAt).utcOffset(3).format('L') === createdLocal.format('L')
                );

                if (!group) {
                    acc.push({
                    createdAt: createdLocal.toISOString(),
                    data: [restOfMessage],
                    });
                } else {
                    group.data.push(restOfMessage);
                }

                return acc.sort((a, b) =>
                    moment.utc(b.createdAt).utcOffset(3).valueOf() -
                    moment.utc(a.createdAt).utcOffset(3).valueOf()
                );
                }, []);
                state.allPastAiMessagesCountNewModel = action.payload.data.count
                state.allPastAiMessagesNewModel = messageHistoryByDate
            })
            .addCase(getAllPastAiNewModelMessages.rejected, (state)=> {
                state.isLoadingGetAllPastAiNewModelMessages = false
            })
            
    }
})


export const { addNewQuestionLocal, getAiQuestionGroupData, setShowedList, updateQuestionList, getUpdateQuestionsData, updateQuestionListUpdate, getAiTitleData, getaAiChatTitleDetails, setAiChatDetails, getAiQuestionItemData, getAiSubTitleData, setSingleAiNewModelChatAllMessages} = aiControlSlice.actions
export default aiControlSlice.reducer